// extracted by mini-css-extract-plugin
export var button = "dark-button-module--button--37cea";
export var darkButton = "dark-button-module--darkButton--428bb";
export var span = "dark-button-module--span--c4d7f";